// extracted by mini-css-extract-plugin
module.exports = {"content":"TextContent_content__3dMwx","collapsed":"TextContent_collapsed__3_-fp","container":"TextContent_container__1HLLp","toggleButton":"TextContent_toggleButton__1wCfl"};